import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";

import { TotalCard, TotalCardTitle, TotalCardValue } from "../../styled";
import Message from "../../../../pages/components/message";
import { MessageSections } from "../../../../pages/components/message/message";
import { numberWithCommas } from "../../../../pages/shared/helper-functions";
import ordersService from "../../../../services/orders.service";
import { DashboardFilterModel } from "../dashboard-filter";

const Card = ({ titleKey, value }: { titleKey: string, value: string | null }) => {
    return (
        <TotalCard>
            <TotalCardTitle>
                <Message messageKey={titleKey} sectionId={MessageSections.ORDERS} />
            </TotalCardTitle>

            <TotalCardValue>
                {value !== null
                    ? value
                    : <CircularProgress />
                }
            </TotalCardValue>
        </TotalCard>
    )
}

export const TotalCards = ({ filter }: { filter: DashboardFilterModel }) => {
    const [data, setData] = useState([
        {
            titleKey: 'total_delivered_orders',
            value: null,
        },
        {
            titleKey: 'total_submitted_payments',
            value: null,
        },
        {
            titleKey: 'total_pending_orders',
            value: null,
        },
        {
            titleKey: 'total_upcoming_payments',
            value: null,
        },
    ]);

    useEffect(() => {
        const totalDeliveredOrders = ordersService.getOrdersCount({ ...filter, state: 5 });
        const submittedPayments = ordersService.getTotalPaymentData({ ...filter, paymentStatus: 2 });
        const totalPending = ordersService.getOrdersCount({ ...filter, state: { $not: { $in: [1, 5] } } });
        const totalUpcomingPayments = ordersService.getTotalPaymentData({ ...filter, paymentStatus: { $not: 2 } });

        Promise.allSettled([
            totalDeliveredOrders,
            submittedPayments,
            totalPending,
            totalUpcomingPayments
        ]).then(responses => {
            const dataClone = JSON.parse(JSON.stringify(data));

            responses.forEach((response, index) => {
                if (response.status === 'fulfilled') {
                    dataClone[index].value = numberWithCommas(response.value.totalItems || response.value.paymentData || 0);
                }
            })

            setData(dataClone);
        })
    }, [filter])

    return (
        <>
            {data.map(({ titleKey, value }) => <Card key={titleKey} titleKey={titleKey} value={value} />)}
        </>
    )
}